import { Card, CardContent } from "@/components/ui/Card";
import { Skeleton } from "@/components/ui/Skeleton";
import { CARD_STYLE } from "../constants";

export function SpecialistCardSkeleton({ delay = 0 }: { delay?: number }) {
  return (
    <Card
      className={`${CARD_STYLE} animate-[skeleton-fade-in_0.3s_ease-out_both]`}
      style={{ animationDelay: `${delay}ms` }}
    >
      <CardContent className="p-4 sm:p-5">
        <div className="flex flex-col md:flex-row gap-3 md:gap-4 mb-4">
          <div className="flex flex-row gap-3 md:gap-4 flex-1">
            <Skeleton className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg shrink-0" />
            <div className="flex-1 min-w-0 space-y-2">
              <div className="flex flex-wrap gap-2 items-center">
                <Skeleton className="h-5 w-28 rounded" />
                <Skeleton className="h-4 w-20 rounded-full" />
              </div>
              <Skeleton className="h-4 w-3/4 max-w-[200px]" />
              <Skeleton className="h-4 w-full max-w-[280px]" />
            </div>
          </div>
          <div className="shrink-0 text-left md:text-right space-y-1">
            <Skeleton className="h-6 w-14 md:mr-0 md:ml-auto rounded" />
            <Skeleton className="h-3 w-20 md:mr-0 md:ml-auto rounded" />
          </div>
        </div>
        <hr className="border-t border-border mb-4" />
        <div>
          <div className="flex items-center gap-1 mb-3">
            <Skeleton className="h-4 w-4 rounded" />
            <Skeleton className="h-4 w-28 rounded" />
          </div>
          <div className="space-y-3">
            <div>
              <Skeleton className="h-3 w-16 mb-2 rounded" />
              <div className="flex flex-wrap gap-2">
                {[1, 2, 3, 4].map((i) => (
                  <Skeleton key={i} className="h-9 w-20 rounded-md" />
                ))}
              </div>
            </div>
            <div>
              <Skeleton className="h-3 w-16 mb-2 rounded" />
              <div className="flex flex-wrap gap-2">
                {[1, 2, 3].map((i) => (
                  <Skeleton key={i} className="h-9 w-20 rounded-md" />
                ))}
              </div>
            </div>
          </div>
          <Skeleton className="h-9 w-full mt-6 rounded-md" />
        </div>
      </CardContent>
    </Card>
  );
}
